// extracted by mini-css-extract-plugin
export default {"accordionSummary":"NavSection_accordionSummary__cqWkk","accordion":"NavSection_accordion__Ly9ka","accordionDetails":"NavSection_accordionDetails__0b8KC"};